import { toast } from "react-toastify";
import { apiget } from "../service/API";

/* Get Banner API */
const get_testimonial = async () => {
  try {
    const getTestimonialResult = await apiget("general-setting/get-testimonial");
    // API Error While Get Testimonial
    if (getTestimonialResult && getTestimonialResult.data.status === false) {
      toast.error(getTestimonialResult.data.message);
      return false;
    }

    // Return Response
    return getTestimonialResult;
  } catch (error) {
    console.error(error);
  }
};

/* Exporting all Functions for reuseing in differnt components */
const testimonial = {
  get_testimonial
};
export default testimonial;